import { combineReducers } from "redux";
import sessionReducer from "./sessionReducer";
import applicationsReducer from "./applicationsReducer";
import applicationMetricReducer from "./applicationMetricReducer";
import { reducer as formReducer } from "redux-form";
import fileReducer from "./fileReducer";
import dashboardReducer from "./dashboardReducer";
import organizationReducer from "./organizationReducer";
import countryReducer from "./countryReducer";
import appListReducer from "./applistReducer";
import fileMetricReducer from "./fileMetricReducer";
import usersReducer from "./usersReducer";
import invitationsReducer from "./invitationsReducer";
import userReducer from "./userReducer";
import applicationReducer from "./applicationReducer";

const rootReducer = combineReducers({
  form: formReducer,
  session: sessionReducer,
  files: fileReducer,
  applications: applicationsReducer,
  application: applicationReducer,
  applicationMetrics: applicationMetricReducer,
  fileMetrics: fileMetricReducer,
  dashboard: dashboardReducer,
  organization: organizationReducer,
  countries: countryReducer,
  appList: appListReducer,
  users: usersReducer,
  user: userReducer,
  invitations: invitationsReducer,
});

export default rootReducer;
